export const LAST_FISCAL_YEAR_SELECTED = "LAST_FISCAL_YEAR_SELECTED";
